import { useContext } from 'react';
import classNames from 'classnames';
import {
  MembershipPackage,
  MembershipPackageName,
  MembershipPackageRecurring,
} from 'common/interfaces/api';
import {
  checkIsChoosingSubbingMembershipPackage,
  isUnPaidSubMembership,
  membershipPricePackagePeriod,
  membershipRecurringLevel,
} from 'common/utils/membership';
import { ScreenName } from 'common/utils/pp_tracking';
import RadioInput from 'components/common/RadioInput';
import useStore from 'store/timeline';

import { MembershipPaymentSectionContext } from '..';
import styles from './LongSubPackageChoose.module.scss';

const LongSubPackageChoose = () => {
  const {
    currentPackage,
    setCurrentPackage,
    membershipPackages,
    currentPaymentBy,
    renewMode,
    screenName,
  } = useContext(MembershipPaymentSectionContext);
  const currentUser = useStore((state) => state.currentUser);
  const longSubPackages = membershipPackages.filter(
    (pack) => pack.package_name === currentPackage.package_name,
  );
  const isOpenFromTradeOpeningLP = screenName === ScreenName.TakaTradeOpeningLP;
  const isUnPaid = isUnPaidSubMembership(currentUser);
  const statusText = () => {
    if (renewMode) return '解除中';
    if (currentUser?.membership?.is_trialing) return '無料体験中';
    if (currentUser?.membership?.is_interval) return '登録中';
    if (isUnPaid) return '決済待ち';
    return '';
  };
  return (
    <div className={styles.longSubPackageChoose}>
      <span className={styles.title}>支払いプランを選択する</span>
      <div className={styles.packagesList}>
        {longSubPackages
          .sort(
            (a, b) =>
              membershipRecurringLevel(a.recurring) -
              membershipRecurringLevel(b.recurring),
          )
          .map((pack, index) => {
            const isChoosingHalfYearPackage =
              currentPackage.package_name === MembershipPackageName.Platinum &&
              currentPackage.recurring === MembershipPackageRecurring.HalfYear;
            const isSubbing = checkIsChoosingSubbingMembershipPackage({
              subbingPackage: currentUser?.membership?.membership_package,
              checkingPackage: pack,
            });
            if (isOpenFromTradeOpeningLP && isChoosingHalfYearPackage) {
              if (pack.recurring === MembershipPackageRecurring.Year) {
                return null;
              }
              if (
                !isSubbing &&
                pack.recurring === MembershipPackageRecurring.Month
              ) {
                return null;
              }
            }
            return (
              <div
                className={classNames(styles.package, {
                  [styles.currentPackage]: currentPackage?.id === pack.id,
                })}
                key={`${pack.package_name}-${index}`}
                onClick={() => setCurrentPackage(pack)}
              >
                <div className={styles.radioInput}>
                  <RadioInput
                    name="priceMembershipPackage"
                    value={pack.recurring}
                    className={styles.radioInput}
                    selectedValue={currentPackage.recurring}
                  />
                </div>
                <span className={styles.name}>
                  {membershipPricePackagePeriod(pack.recurring)}プラン
                </span>
                {isSubbing && statusText() && (
                  <span
                    className={classNames(styles.isSubbingFlag, {
                      [styles.isRed]: isUnPaid || renewMode,
                    })}
                  >
                    {statusText()}
                  </span>
                )}
                <span className={styles.line}></span>
                <div className={styles.price}>
                  <span className={styles.number}>
                    {showingPrice(pack, currentPaymentBy)}
                    {currentPaymentBy === 'credit' ? '円' : 'コイン'}/
                    {membershipPricePackagePeriod(pack.recurring)}
                  </span>
                  {showingPackLabel(pack, currentPaymentBy)}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

const showingPrice = (
  pack: MembershipPackage,
  currentPaymentBy: 'coin' | 'credit',
) => {
  if (
    pack.discounted_web_amount > 0 &&
    pack.web_amount > pack.discounted_web_amount &&
    currentPaymentBy === 'credit'
  ) {
    return (
      <span>
        <del style={{ marginRight: '4px' }}>
          {pack.web_amount?.toLocaleString()}
        </del>
        {pack.discounted_web_amount?.toLocaleString()}
      </span>
    );
  }
  return pack.web_amount?.toLocaleString();
};

const showingPackLabel = (
  pack: MembershipPackage,
  currentPaymentBy: 'coin' | 'credit',
) => {
  const discountLabel =
    currentPaymentBy === 'credit' ? pack.discount_label?.trim() : '';

  return (
    <>
      {discountLabel && (
        <span className={styles.textCampaign}>{discountLabel}</span>
      )}
      <span className={styles.text}>
        新規プライム登録{' '}
        <span className={styles.big}>
          {pack.prime_subscription_discount_percentage}%割引
        </span>
      </span>
    </>
  );
};

export default LongSubPackageChoose;
